// Modul belajar Matematika – elemen Data.
import { barChart, pictogram, freqTable } from '../../subjects/matematika/gambar.js';

const IKON_DATA = '<svg viewBox="0 0 64 64"><rect x="6" y="6" width="52" height="52" rx="10" fill="var(--surface)" stroke="var(--edge)" stroke-width="3"/><rect x="14" y="30" width="8" height="20" rx="2" fill="var(--sky)" stroke="var(--edge)" stroke-width="2.5"/><rect x="28" y="16" width="8" height="34" rx="2" fill="var(--pink)" stroke="var(--edge)" stroke-width="2.5"/><rect x="42" y="24" width="8" height="26" rx="2" fill="var(--sun)" stroke="var(--edge)" stroke-width="2.5"/></svg>';

const BUAH = [{ id: 'apel', nama: 'Apel' }, { id: 'jeruk', nama: 'Jeruk' }, { id: 'mangga', nama: 'Mangga' }, { id: 'pisang', nama: 'Pisang' }];
const JAWABAN = ['mangga', 'apel', 'jeruk', 'mangga', 'pisang', 'mangga', 'apel', 'mangga', 'jeruk', 'pisang', 'mangga', 'apel', 'mangga', 'jeruk'];

export const MODUL_DATA = [
  {
    id: 'membaca-data', mapel: 'matematika', elemen: 'Data', warna: 'sky', menit: 10, ikon: IKON_DATA,
    judul: 'Tabel, diagram batang & piktogram',
    ringkas: 'Catat data dengan turus, susun diagram batang, baca piktogram, dan temukan modus.',
    topik: ['diagram-batang', 'piktogram', 'tabel-frekuensi', 'kesimpulan-data'], rumus: ['tabel-frekuensi', 'diagram-batang', 'piktogram', 'modus'],
    ringkasan: [
      '**Turus** dipakai untuk mencatat data. Setiap kelompok lima: empat garis tegak dicoret satu garis miring.',
      '**Frekuensi** = berapa kali data muncul. Jumlah semua frekuensi = banyak data.',
      '**Modus** = data yang paling sering muncul (frekuensinya paling besar).',
      'Membaca **diagram batang**: lihat ujung batang, lalu tarik garis ke angka di sumbu tegak.',
      'Membaca **piktogram**: hitung ikonnya, lalu kalikan dengan nilai satu ikon (setengah ikon = setengah nilainya).',
    ],
    langkah: [
      {
        label: 'Mencatat data', judul: 'Catat dengan turus',
        narasi: 'Bu Guru bertanya ke 14 siswa: "Buah apa yang paling kamu sukai?" Supaya tidak ada yang terlewat, kita catat setiap jawaban dengan **turus**.',
        tugas: 'Untuk setiap jawaban yang muncul, ketuk nama buah yang sama di tabel.',
        widget: { tipe: 'turus', judul: 'Buah kesukaan siswa kelas 6', kolom: 'Buah', kategori: BUAH, data: JAWABAN },
      },
      {
        label: 'Modus', judul: 'Data yang paling sering muncul',
        narasi: 'Hasil turus tadi menjadi **tabel frekuensi**. Data yang frekuensinya paling besar disebut **modus**. Di tabel ini, modusnya adalah **mangga** (6 siswa).',
        visual: () => freqTable('Buah', ['Apel', 'Jeruk', 'Mangga', 'Pisang'], [3, 3, 6, 2], 'Buah kesukaan siswa kelas 6'),
      },
      {
        jenis: 'kuis', judul: 'Hitung banyak data',
        soal: 'Dari tabel frekuensi di bawah, berapa **banyak siswa seluruhnya**?',
        visual: () => freqTable('Nilai', ['6', '7', '8', '9', '10'], [4, 7, 9, 5, 2], 'Nilai ulangan matematika'),
        isian: { jawaban: 27, satuan: 'siswa' },
        petunjuk: 'Banyak data = jumlah semua frekuensi.',
        bahas: '4 + 7 + 9 + 5 + 2 = **27** siswa. Modusnya nilai **8**, karena frekuensinya paling besar (9).',
      },
      {
        label: 'Diagram batang', judul: 'Dari tabel ke diagram batang',
        narasi: 'Diagram batang memudahkan kita membandingkan data. Setiap batang tingginya sesuai angka di tabel.',
        tugas: 'Atur tinggi setiap batang sesuai tabel (seret batangnya atau pakai tombol + dan −).',
        widget: { tipe: 'buatDiagram', judul: 'Buku yang dibaca dalam sebulan', satuan: 'Buku', kolom: 'Nama', label: ['Ana', 'Budi', 'Cici', 'Dodi', 'Eka'], nilai: [4, 7, 5, 2, 6], maks: 8, langkah: 1 },
      },
      {
        label: 'Membaca diagram', judul: 'Tertinggi, terendah, dan selisih',
        narasi: 'Saat membaca diagram batang, lihat **ujung batang** lalu tarik garis lurus ke angka di sumbu kiri. Selisih berarti nilai yang besar **dikurangi** nilai yang kecil.',
        tugas: 'Ikuti petunjuk di atas diagram: ketuk batang tertinggi, terendah, lalu pilih selisihnya.',
        widget: { tipe: 'bacaDiagram', judul: 'Penjualan roti', satuan: 'roti', label: ['Sen', 'Sel', 'Rab', 'Kam', 'Jum'], nilai: [35, 50, 25, 45, 40], maks: 60, langkah: 10 },
      },
      {
        jenis: 'kuis', judul: 'Baca diagramnya',
        soal: 'Diagram di bawah menunjukkan banyak pengunjung perpustakaan. Berapa **selisih** pengunjung hari Selasa dan Kamis?',
        visual: () => barChart(['Sen', 'Sel', 'Rab', 'Kam', 'Jum'], [30, 45, 20, 25, 40], 5, 'Pengunjung perpustakaan', 'orang'),
        pilihan: ['15 orang', '20 orang', '25 orang', '70 orang'], kunci: 1,
        petunjuk: 'Baca dulu nilai Selasa dan Kamis, lalu kurangkan.',
        bahas: 'Selasa **45** orang, Kamis **25** orang. Selisihnya 45 − 25 = **20** orang.',
      },
      {
        label: 'Piktogram', judul: 'Satu gambar mewakili beberapa',
        narasi: 'Pada **piktogram**, satu ikon bisa mewakili lebih dari satu benda. Perhatikan keterangannya! Kalau 1 ikon = 4 buku, maka setengah ikon = 2 buku.',
        tugas: 'Lengkapi piktogram supaya setiap kelas sesuai datanya.',
        widget: { tipe: 'piktogram', judul: 'Buku yang disumbangkan', ikon: 'buku', per: 4, satuan: 'buku', baris: [{ label: 'Kelas 6A', nilai: 12 }, { label: 'Kelas 6B', nilai: 10 }, { label: 'Kelas 6C', nilai: 6 }] },
      },
      {
        jenis: 'kuis', judul: 'Baca piktogramnya',
        soal: 'Berapa banyak bunga di **Taman B**?',
        visual: () => pictogram([{ n: 'Taman A', full: 3, half: 0 }, { n: 'Taman B', full: 4, half: 1 }, { n: 'Taman C', full: 2, half: 1 }], 10, 'bunga', 'Bunga di taman kota', 'bunga'),
        isian: { jawaban: 45, satuan: 'bunga' },
        petunjuk: 'Taman B punya 4 ikon utuh dan setengah ikon. Satu ikon = 10 bunga.',
        bahas: '4 ikon utuh = 4 × 10 = 40 bunga, setengah ikon = 5 bunga. Jadi **45** bunga.',
      },
      {
        jenis: 'kuis', judul: 'Benar atau salah?',
        soal: 'Perhatikan tabel frekuensi tinggi badan berikut, lalu tentukan **Benar** atau **Salah**.',
        visual: () => freqTable('Tinggi (cm)', ['140', '145', '150', '155'], [5, 8, 6, 3], 'Tinggi badan siswa'),
        bs: [
          { teks: 'Modus tinggi badan adalah 145 cm.', benar: true },
          { teks: 'Banyak siswa seluruhnya 20 orang.', benar: false },
          { teks: 'Siswa yang tingginya 150 cm atau lebih ada 9 orang.', benar: true },
        ],
        petunjuk: 'Cari frekuensi terbesar untuk modus, jumlahkan semua frekuensi, dan jumlahkan frekuensi 150 dan 155.',
        bahas: 'Frekuensi terbesar 8 → modus **145 cm** (benar). Jumlah 5 + 8 + 6 + 3 = **22**, bukan 20 (salah). Tinggi 150 dan 155: 6 + 3 = **9** orang (benar).',
      },
    ],
  },
];
